import { convertDate } from '@usucampeao/interfaces';
import { Transform } from 'class-transformer';

export function ConvertDate() {
  return Transform(data => convertDate(data.value))
}
